import { GzTrialHomePageWebComponent } from './component/GzTrialHomePageWebComponent';

export { GzTrialHomePageWebComponent };
